/* eslint-disable react/button-has-type */
/* eslint-disable no-unused-vars */
/* eslint-disable no-plusplus */
/* eslint-disable radix */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import { useState, useEffect, useRef, useLayoutEffect } from "react";
import { Box, Typography, Button, Tabs, Tab, Grid, Paper, Card, Accordion, AccordionSummary, AccordionDetails, Divider } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { TrendingUp } from "lucide-react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export function ScoreCardAnalytics({ analysis, selectedAttemptIndex }) {

  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-6">
      <div className="flex justify-between items-center mb-5">
        <span className="text-base font-bold text-gray-900">Your Section Performance 
</span>
        <span className="text-sm text-gray-400">Attempt {selectedAttemptIndex + 1}</span>
      </div>
      {analysis && analysis?.length > 0 && analysis?.map((section, si) => {
        const correct = section.questions.filter(q => q.userResponse === "correct").length;
        const wrong = section.questions.filter(q => q.userResponse === "incorrect").length;
        const unanswered = section.questions.filter(q => q.userResponse === null || q.userResponse === "unattempted").length;
        const total = section.questions.length;
        const pct = total > 0 ? Math.round((correct / total) * 100) : 0;

        return (
          <div key={section.module_id}>
            {si > 0 && <hr className="border-gray-100 my-5" />}

            <div className="mb-5 last:mb-0">
              <div className="flex justify-between items-baseline mb-1.5">
                <span className="text-sm font-medium text-gray-800">{section.module_name}</span>
                <span className="text-sm font-medium text-gray-800">
                  <strong>{correct}/{total}</strong>{" "}
                  <span className="font-normal text-gray-400 text-xs">marks</span>
                </span>
              </div>

              <div className="h-2 bg-gray-100 rounded-full overflow-hidden mb-1.5">
                <div
                  className="h-full bg-amber-400 rounded-full transition-all"
                  style={{ width: `${pct}%` }}
                />
              </div>

              <div className="flex justify-between items-center">
                <div className="flex gap-3 text-xs">
                  <span className="text-green-600 font-medium">{correct} correct</span>
                  <span className="text-red-500 font-medium">{wrong} wrong</span>
                  <span className="text-gray-400">{unanswered} skipped</span>
                </div>
                <span className="text-xs text-gray-500">{pct}%</span>
              </div>
            </div>
          </div>
        );
      })}
      {/* {analysis && analysis?.length > 0 && analysis?.map((section, si) => {
        const pct = section.percentage;
        return (
          <div key={section.module_id}>
            {si > 0 && <hr className="border-gray-100 my-5" />}

            <div className="mb-5 last:mb-0">
              <div className="flex justify-between items-baseline mb-1.5">
                <span className="text-sm font-medium text-gray-800">{section.module_name}</span>
                <span className="text-sm font-medium text-gray-800">
                  <strong>{section.correct}/{section.total}</strong>{" "}
                  <span className="font-normal text-gray-400 text-xs">marks</span>
                </span>
              </div>

              <div className="h-2 bg-gray-100 rounded-full overflow-hidden mb-1.5">
                <div
                  className="h-full bg-amber-400 rounded-full transition-all"
                  style={{ width: `${pct}%` }}
                />
              </div>

              <div className="flex justify-between items-center">
                <div className="flex gap-3 text-xs">
                  <span className="text-green-600 font-medium">{section.correct} correct</span>
                  <span className="text-red-500 font-medium">{section.wrong} wrong</span>
                  <span className="text-gray-400">{section.unanswered} skipped</span>
                </div>
                <span className="text-xs text-gray-500">{pct}%</span>
              </div>
            </div>
          </div>
        );
      })} */}
    </div>
  );
}

function getColorClass(q, perQuestionTimeMins) {
  const targetSec = perQuestionTimeMins * 60;
  if (q.timetaken === null || q.timetaken === undefined || q.userResponse === null || q.userResponse === "unattempted") {
    return "gray";
  }
  const isCorrect = q.userResponse === "correct";
  const isSlow = q.timetaken > targetSec;
  if (isCorrect && !isSlow) return "green";
  if (isCorrect && isSlow) return "yellow";
  return "red";
}

const COLOR_STYLES = {
  green: { bg: "bg-emerald-500", hover: "hover:bg-emerald-600", text: "text-emerald-600", label: "On pace", dot: "#10b981" },
  yellow: { bg: "bg-amber-400", hover: "hover:bg-amber-500", text: "text-amber-500", label: "Slow", dot: "#f59e0b" },
  red: { bg: "bg-rose-500", hover: "hover:bg-rose-600", text: "text-rose-500", label: "Wrong", dot: "#f43f5e" },
  gray: { bg: "bg-gray-300", hover: "hover:bg-gray-400", text: "text-gray-400", label: "skipped", dot: "#d1d5db" },
};

function stripHtml(html) {
  if (!html) return "";
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
}

function TooltipView({ q, index, color, showBelow }) {
  return (
    <div
      className={`absolute z-50 left-1/2 -translate-x-1/2 w-52 bg-white border border-gray-200 rounded-xl shadow-lg p-3 pointer-events-none
      ${showBelow ? "top-full mt-2 ml-5" : "bottom-full mb-2"}`}>
      <div className="flex items-center justify-between mb-1">
        <span className="text-xs font-semibold text-gray-700">Q{index + 1}</span>
        <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${color === "green" ? "bg-emerald-100 text-emerald-700" :
          color === "yellow" ? "bg-amber-100 text-amber-700" :
            color === "red" ? "bg-rose-100 text-rose-700" :
              "bg-gray-100 text-gray-500"
          }`}>
          {COLOR_STYLES[color].label}
        </span>
      </div>
      <p className="text-xs text-gray-600 leading-snug mb-2 line-clamp-2">
        {stripHtml(q.question_text)}
      </p>
      <div className="flex flex-col gap-0.5 text-xs text-gray-500">
        <div className="flex justify-between">
          <span>Level</span>
          <span className="font-medium capitalize text-gray-700">{q.level}</span>
        </div>
        <div className="flex justify-between">
          <span>Time taken</span>
          <span className="font-medium text-gray-700">{q.timetaken != null ? `${q.timetaken.toFixed(2)}s` : "—"}</span>
        </div>
        <div className="flex justify-between">
          <span>Response</span>
          <span className={`font-medium capitalize ${q.userResponse === "correct" ? "text-emerald-600" :
            q.userResponse === "incorrect" ? "text-rose-500" : "text-gray-400"
            }`}>{q.userResponse ?? "skipped"}</span>
        </div>
      </div>
    </div>
  );
}

function QuestionDot({ q, index, perQuestionTime, showBelow }) {
  const [show, setShow] = useState(false);
  const color = getColorClass(q, perQuestionTime);
  const { bg, hover } = COLOR_STYLES[color];

  return (
    <div
      className="relative"
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      <div
        className={`w-7 h-7 rounded-md cursor-pointer transition-all duration-150 ${bg} ${hover} hover:scale-110 active:scale-95`}
      />
      {show && <TooltipView q={q} index={index} color={color} showBelow={showBelow} />}
    </div>
  );
}

function ModuleCard({ mod }) {
  const perq = mod.perquestion_time;
  const targetSec = Math.round(perq * 60);

  const questionCount = parseInt(mod.module_questions || 0, 10);

  const normalizedQuestions =
    mod.questions && mod.questions.length > 0
      ? mod.questions
      : Array.from({ length: questionCount }, (_, i) => ({
        id: `dummy-${i}`,
        question_text: "Unanswered question",
        level: "—",
        userResponse: null,
        timetaken: null,
      }));

  let totalTime = 0;
  let answeredCount = 0;
  let slowCount = 0;

  normalizedQuestions.forEach((q) => {
    if (q.timetaken != null) {
      totalTime += q.timetaken;
      answeredCount++;
      if (q.timetaken > targetSec && q.userResponse !== null && q.userResponse !== "incorrect") {
        slowCount++;
      }
    }
  });

  const avgSec = answeredCount > 0 ? Math.round(totalTime / answeredCount) : 0;

  const isEnglish = mod.module_name.toLowerCase().includes("english");
  const prefix = isEnglish ? "R&W" : "Math";
  const moduleNum = parseInt(mod.module_id) % 2 === 0 ? "Module 1" : "Module 2";

  return (
    <div className="bg-white border border-gray-100 rounded-2xl p-5 shadow-sm">

      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1.5 sm:gap-0 mb-4">
        <h3 className="text-sm font-semibold text-gray-800">
          <span className="text-gray-400 font-normal">{prefix} · </span>
          {moduleNum}
          <span className="ml-2 text-xs font-normal text-gray-400">
            ({mod.module_name})
          </span>
        </h3>

        <div className="flex flex-wrap sm:flex-nowrap items-center gap-x-3 gap-y-1 text-xs text-gray-400">
          <span>avg {avgSec}s</span>
          <span className="text-gray-200">·</span>
          <span>target {targetSec}s</span>
          <span className="text-gray-200">·</span>
          <span className={slowCount > 0 ? "text-amber-500 font-semibold" : "text-gray-400"}>
            {slowCount} slow
          </span>
        </div>
      </div>
      <div className="flex flex-wrap gap-1.5 mb-4">
        {normalizedQuestions.map((q, i) => (
          <QuestionDot
            key={q.id}
            q={q}
            index={i}
            perQuestionTime={mod.perquestion_time}
            showBelow={i < 15}
          />
        ))}
      </div>

      <div className="flex flex-wrap sm:flex-nowrap items-center gap-x-5 gap-y-1">
        {Object.entries(COLOR_STYLES).map(([key, val]) => (
          <div key={key} className="flex items-center gap-1.5">
            <div
              className="w-2.5 h-2.5 rounded-sm"
              style={{ backgroundColor: val.dot }}
            />
            <span className="text-xs text-gray-400">{val.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function SummaryBar({ data }) {
  if (!data || !Array.isArray(data)) return null;
  const totals = data.reduce(
    (acc, mod) => {
      const questionCount = parseInt(mod.module_questions || mod.total || 0, 10);

      const hasRealQuestions = mod.questions && mod.questions.length > 0;

      const correct = mod.correct || 0;
      const wrong = mod.wrong || 0;

      const skipped = hasRealQuestions ? mod.unanswered || 0 : questionCount;
      acc.correct += correct;
      acc.wrong += wrong;
      acc.unanswered += skipped;
      acc.total += questionCount;

      return acc;
    },
    { correct: 0, wrong: 0, unanswered: 0, total: 0 }
  );

  const stats = [
    { label: "Correct", value: totals.correct, color: "text-emerald-600", bg: "bg-emerald-50 border-emerald-100" },
    { label: "Wrong", value: totals.wrong, color: "text-rose-500", bg: "bg-rose-50 border-rose-100" },
    { label: "Skipped", value: totals.unanswered, color: "text-gray-400", bg: "bg-gray-50 border-gray-100" },
    { label: "Total", value: totals.total, color: "text-gray-700", bg: "bg-white border-gray-100" }];

  return (
    // Mobile: 2 columns (2x2 grid). sm and up: original 4-in-a-row layout, unchanged.
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-6">
      {stats.map((s) => (
        <div key={s.label} className={`rounded-xl border p-3 ${s.bg}`}>
          <p className="text-xs text-gray-400 mb-1">{s.label}</p>
          <p className={`text-2xl font-semibold ${s.color}`}>{s.value}</p>
        </div>
      ))}
    </div>
  );
}

export function PacingAnalysis({ analysis, selectedAttemptIndex }) {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-6">

      <div className="mx-auto">
        <div className="mb-6">
          <div className="flex items-center gap-2 mb-1">
            <svg className="w-5 h-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
              <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" fill="none" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 7v5l3 2" />
            </svg>
            <h1 className="text-xl font-semibold text-gray-900">Pacing Analysis</h1>
          </div>
          <p className="text-sm text-gray-400 ml-7">Each square = one question. Color shows pace and correctness.</p>
        </div>

        <SummaryBar data={analysis} />

        <div className="flex flex-col gap-4">
          {analysis && analysis?.map((mod) => (
            <ModuleCard key={mod.module_id} mod={mod} />
          ))}
        </div>
      </div>
    </div>
  );
}

function ProgressLine({ attempts }) {

  const svgRef = useRef(null);
  const [dims, setDims] = useState({ width: 400, height: 140 });

  useEffect(() => {
    const obs = new ResizeObserver((entries) => {
      const { width, height } = entries[0].contentRect;
      setDims({ width, height });
    });
    if (svgRef.current) obs.observe(svgRef.current.parentElement);
    return () => obs.disconnect();
  }, []);

  if (!attempts.length) return null;

  const PAD_X = 30;
  const PAD_Y = 20;
  const usableW = dims.width - PAD_X * 2;
  const usableH = dims.height - PAD_Y * 2;

  const scores = attempts.map((a) => a.score);
  const minScore = Math.min(...scores) - 50;
  const maxScore = Math.max(...scores) + 50;

  const safeDiv = attempts.length === 1 ? 1 : attempts.length - 1;

  const xOf = (i) => PAD_X + (i / safeDiv) * usableW;
  const yOf = (score) =>
    PAD_Y + usableH - ((score - minScore) / (maxScore - minScore)) * usableH;

  const points = attempts.map((a, i) => ({
    x: xOf(i),
    y: yOf(a.score),
  }));

  const pathD = points
    .map((p, i) => `${i === 0 ? "M" : "L"} ${p.x} ${p.y}`)
    .join(" ");

  return (
    <div className="relative w-full" style={{ height: dims.height }}>
      <svg ref={svgRef} width="100%" height={dims.height}>
        <line
          x1={PAD_X}
          y1={dims.height / 2}
          x2={dims.width - PAD_X}
          y2={dims.height / 2}
          stroke="#e2e8f0"
          strokeWidth="2"
          strokeDasharray="4 3"
        />

        <path d={pathD} fill="none"
          stroke="#3b5bdb"
          strokeWidth="2.5"
          strokeLinecap="round"
        />

        {attempts.map((a, i) => {
          const { x, y } = points[i];
          return (
            <g key={i}>
              <circle cx={x} cy={y} r={6} fill="white" stroke="#3b5bdb" strokeWidth="2.5" />
              <circle cx={x} cy={y} r={3} fill="#3b5bdb" />
              <text x={x} y={y - 12} textAnchor="middle" fontSize="11" fill="#374151" fontWeight="600">
                {a.score}
              </text>
              <text x={x} y={dims.height - 2} textAnchor="middle" fontSize="11" fill="#9ca3af">
                {a.label}
              </text>
            </g>
          );
        })}
      </svg>
    </div>
  );
}

export function ScoreProgression({ analysis, selectedAttemptIndex, assessmentdetails1, userRole }) {
  const isFreeAssessment =
    assessmentdetails1?.is_payment === false &&
    assessmentdetails1?.ispaid === false;


  const attempts = (analysis?.scoreProgression || [])
    .filter(a => typeof a?.totalScore === "number")
    .map((a, i) => ({
      label: isFreeAssessment || userRole === 'AUTH_USER'
        ? `A${i + 1}`
        : (i === 0 ? "Free A1" : `A${i + 1}`),
      score: a.totalScore ?? 0,
    }));

  if (attempts.length === 0) {
    return (
      <div className="bg-white rounded-2xl border border-gray-200 p-10 text-center">
        <p className="text-gray-400 text-sm font-medium">
          No test attempts yet. Your score progression will appear here after you complete a test.
        </p>
      </div>
    );
  }

  // const safeIndex = selectedAttemptIndex !== undefined && selectedAttemptIndex !== null ? Math.min(selectedAttemptIndex, attempts.length - 1): 0;

  const safeIndex = selectedAttemptIndex != null && selectedAttemptIndex < attempts.length ? selectedAttemptIndex : 0;

  const latestScore = attempts[safeIndex]?.score ?? 0;
  const prevScore = safeIndex > 0 ? attempts[safeIndex - 1]?.score ?? latestScore : latestScore;
  const delta = latestScore - prevScore;
  const isUp = delta >= 0;
  const target = assessmentdetails1?.assessment_type === 'Subject Test' ? 800 : 1600;
  const progressPct = Math.round((latestScore / target) * 100);


  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-6 min-h-[380px]">
      <div className="flex items-center justify-between mb-5">
        <span className="flex items-center gap-2 text-sm font-semibold text-gray-700">
          <TrendingUp color="#2563eb" size={20} />
          <span>Score Progression</span>
        </span>

        <div
          className={`flex items-center gap-1 px-3 py-1 rounded-full text-sm font-semibold border ${isUp
            ? "bg-emerald-50 text-emerald-600 border-emerald-100"
            : "bg-rose-50 text-rose-500 border-rose-100"
            }`}
        >
          {isUp ? "+" : ""}
          {delta}
        </div>
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center gap-6 sm:gap-8">
        <div className="shrink-0 w-full sm:w-auto">
          <div className="flex items-baseline gap-1">
            <span className="text-5xl font-bold text-gray-900">
              {latestScore}
            </span>
            <span className="text-lg text-gray-400 font-medium">
              /{target}
            </span>
          </div>

          <div className="mt-2 w-full sm:w-40 h-1.5 bg-gray-100 rounded-full overflow-hidden">
            <div className="h-full rounded-full bg-blue-600 transition-all duration-700" style={{ width: `${Math.min(progressPct, 100)}%` }} />
          </div>
          <p className="text-xs text-gray-400 mt-1">
            {progressPct}% of target
          </p>
        </div>

        <div className="flex-1 min-w-0 w-full flex items-center">
          <ProgressLine attempts={attempts} />
        </div>
      </div>
    </div>
  );
}


export function QuestionWiseAnalysis({ activeTabs, handleTabChangeTabs, visibleTabs, allQuestions }) {
  const [expanded, setExpanded] = useState(null);
  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  const normalizedQuestions = allQuestions && allQuestions?.length > 0 && allQuestions.map((q) => {
    if (q.question_type?.toUpperCase() === "NUMERIC") {
      const selected = parseFloat(q.selectedAnswer);
      const correct = parseFloat(q.answer?.acceptableAnswers);

      const isCorrect =
        !Number.isNaN(selected) &&
        !Number.isNaN(correct) &&
        Math.abs(selected - correct) < 0.000001;

      return {
        ...q,
        userResponse: isCorrect ? "correct" : q.userResponse,
        status: isCorrect ? "correct" : q.status,
      };
    }

    return q;
  });

  const INITIAL_COUNT = 4; 
  const STEP = 4;        
  const [visibleCount, setVisibleCount] = useState(INITIAL_COUNT);

  useEffect(() => {
    setVisibleCount(INITIAL_COUNT);
    setExpanded(null);
  }, [activeTabs, allQuestions]);

  const totalQuestions = normalizedQuestions ? normalizedQuestions.length : 0;
  const hasMore = visibleCount < totalQuestions;

  useLayoutEffect(() => {
    const savedScrollPosition = sessionStorage.getItem('scrollPosition');
    if (savedScrollPosition) {
      window.scrollTo(0, parseInt(savedScrollPosition, 10));
    }
  }, [activeTabs]);


  useEffect(() => {
    const handleScroll = () => {
      sessionStorage.setItem('scrollPosition', window.scrollY);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isPassageVisible = true
  // sectionDetails[
  //     visibleTabs.findIndex((tab) => tab.id === activeTabs)
  // ]?.questionType === "PASSAGE_SINGLE";

  const useMobileLandscape = () => {
    const [isMobileLandscape, setIsMobileLandscape] = useState(
      window.innerWidth > 600 && window.innerHeight <= 455
    );

    useEffect(() => {
      const handleResize = () => {
        setIsMobileLandscape(
          window.innerWidth > 600 && window.innerHeight <= 455
        );
      };
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
    return isMobileLandscape;
  }

  const mobileLandscape = useMobileLandscape();

  const normalizeText = (str) => {
    if (!str) return "";
    const s = str.toString();
    const imgMatch = s.match(/<img[^>]+src=["']([^"']+)["']/i);
    if (imgMatch) {
      return imgMatch[1].trim();
    }

    return s.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ").trim().toLowerCase();
  };

  const isMultiAnswer = (q) => {
    const t = q.question_type?.toUpperCase();
    return t === 'MCQ_MULTI' || t === 'MULTIPLE CHOICE';
  };

  const getSelectedLabelCompact = (question) => {
    try {
      const parsedAnswer =
        typeof question.answer === "string"
          ? JSON.parse(question.answer)
          : question.answer || {};

      const options = Array.isArray(parsedAnswer?.mcqOptions) ? parsedAnswer.mcqOptions : [];

      if (question.question_type?.toUpperCase() === 'NUMERIC') {
        return question.selectedAnswer ?? '-';
      }
      if (isMultiAnswer(question)) {
        const selectedArr = Array.isArray(question.selectedAnswer)
          ? question.selectedAnswer
          : (question.selectedAnswer ? [question.selectedAnswer] : []);
        if (selectedArr.length === 0) return '-';
        const labels = selectedArr.map(s => {
          const idx = options.findIndex(opt => normalizeText(opt) === normalizeText(s));
          return idx !== -1 ? String.fromCharCode(65 + idx) : '-';
        });
        return labels.join(', ');
      }
      let selected = question.selectedAnswer;
      if (typeof selected === "string") {
        try {
          const parsed = JSON.parse(selected);
          if (Array.isArray(parsed)) selected = parsed[0];
          else if (typeof parsed === "object" && parsed !== null) selected = parsed.value || parsed.option || "";
          else selected = parsed;
        } catch {
          // Not JSON, keep as-is
        }
      }
      const normalizedSelected = normalizeText(selected);
      const selectedIndex = options.findIndex((opt) => normalizeText(opt) === normalizedSelected);
      return selectedIndex !== -1 ? String.fromCharCode(65 + selectedIndex) : "-";
    } catch (err) {
      return "-";
    }
  };

  const getCorrectLabelCompact = (question) => {
    try {
      const parsedAnswer =
        typeof question.answer === "string"
          ? JSON.parse(question.answer)
          : question.answer;

      if (question.question_type?.toUpperCase() === 'NUMERIC') {
        if (parsedAnswer?.answerType === 'range') {
          return `${parsedAnswer.minValue} – ${parsedAnswer.maxValue}`;
        }
        return parsedAnswer?.acceptableAnswers || '-';
      }

      const correctAnswers = parsedAnswer?.correctAnswer || [];

      if (isMultiAnswer(question)) {
        const correctLabels = correctAnswers
          .map((val, idx) => (val ? String.fromCharCode(65 + idx) : null))
          .filter(Boolean);
        return correctLabels.join(', ') || '-';
      }

      const correctIndex = correctAnswers.findIndex((ans) => ans === true);
      return correctIndex !== -1 ? String.fromCharCode(65 + correctIndex) : "-";
    } catch (err) {
      return "-";
    }
  };

  return (
    <>
      <div className="bg-white rounded-2xl border border-gray-200 p-4 sm:p-6 min-w-0">

      <Typography variant="h5" sx={{ fontWeight: 600, fontSize: { xs: '14px', sm: '26px', md: '26px' } }}>
        Let's Understand Your Mistakes
      </Typography>

       <p style={{ margin: "4px 0 0", fontSize: 13, color: "#6B7280" }}>
           Review your answers, see what went wrong and learn from the explaination.
        </p>
      <Tabs value={activeTabs} onChange={handleTabChangeTabs}
        id="tabSwitcher"
        variant="scrollable"
        scrollButtons={false}
        sx={{
          borderBottom: '1px solid #ddd',
          minHeight: 40,
          marginTop: 4,

          '& .MuiTabs-indicator': {
            height: 3,
            borderRadius: 3,
            backgroundColor: '#3d88fa',
          },

          '& .MuiTabs-scroller': {
            overflowX: 'auto !important',
            scrollbarWidth: 'none',

            '&::-webkit-scrollbar': {
              display: 'none',
            },
          },

          '& .MuiTabs-flexContainer': {
            display: 'flex',
            width: 'max-content',
            minWidth: '100%',
            gap: {
              xs: 0.5,
              sm: 1,
              md: 1,
            },
          },
        }}
      >
        {visibleTabs?.map((tab) => (
          <Tab
            key={tab.id}
            value={tab.id}
            label={tab.name}
            sx={{
              textTransform: 'none',

              minHeight: 40,
              minWidth: {
                xs: 90,
                sm: 110,
                md: 120,
              },

              flex: '0 0 auto',

              px: {
                xs: 1.5,
                sm: 2,
                md: 2.5,
              },

              py: 0.75,

              fontWeight: 600,
              fontSize: {
                xs: 11,
                sm: 13,
                md: 14,
              },

              whiteSpace: 'nowrap',

              color:
                activeTabs === tab.id
                  ? '#3d88fa !important'
                  : '#000',

              backgroundColor:
                activeTabs === tab.id
                  ? '#f0f4ff'
                  : '#fff',

              borderBottom:
                activeTabs === tab.id
                  ? '2px solid #3d88fa !important'
                  : 'none',
            }}
          />
        ))}
      </Tabs>

      <Box sx={{ mt: 4 }}>

        {normalizedQuestions && normalizedQuestions?.length > 0 ? normalizedQuestions.slice(0, visibleCount).map((question, index) => (
          <Card
            key={question.id}
            sx={{
              borderRadius: 1,
              boxShadow: "none",
              border: "1px solid #e0e0e0",
              mb: 2,
              overflow: "hidden",
              background: "#fff",
            }}
          >
            <Accordion expanded={expanded === question.id}
              sx={{
                "&:before": { display: "none" },
                boxShadow: "none",
              }}
            >
              <AccordionSummary
                sx={{
                  backgroundColor: "#ffffff",
                  p: { xs: '10px 10px', sm: '12px 14px', md: 2 },
                  "& .MuiAccordionSummary-content": {
                    display: "flex",
                    flexDirection: { xs: 'row', sm: 'row', md: 'row' },
                    alignItems: { xs: 'flex-start', sm: 'flex-start', md: 'center' },
                    justifyContent: { xs: 'flex-start', sm: 'flex-start', md: 'flex-start' },
                    flexWrap: "wrap",
                    gap: { xs: 1, sm: 1.5, md: 3 },
                    minWidth: 0,
                  },
                }}
              >
                <Box sx={{
                  display: "flex", alignItems: "center", width: 25, height: 28, justifyContent: "center", gap: 0.5,
                  backgroundColor: "#E9EFFD", borderRadius: { xs: '4px', sm: '4px', md: '4px' }, alignSelf: 'baseline',
                  p: 1.2, fontSize: { xs: 10, sm: 13, md: 13 }, fontWeight: 600, textTransform: "capitalize",
                }} >
                  {index + 1}
                </Box>

                <Box sx={{
                  display: { xs: 'flex', sm: 'flex', md: 'none' },
                  flexDirection: 'column',
                  flex: 1,
                  minWidth: 0,
                  gap: 1,
                  px: { xs: 1, sm: 1.5 },
                  py: { xs: 0.5, sm: 0.75 },
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', gap: 1 }}>
                    <Box sx={{
                      display: "flex", alignItems: "center", width: { xs: 100, sm: 130, md: 130 }, height: 30, justifyContent: "center", gap: 0.5,
                      backgroundColor: question.userResponse === "correct" ? "#e8f5e9" : (question.userResponse === null || question.userResponse === "unattempted") ? "#e3e8ef" : "#ffebee",
                      color: question.userResponse === "correct" ? "#2e7d32" : (question.userResponse === null || question.userResponse === "unattempted") ? "#3F3F3F" : "#d32f2f",
                      px: 1.2, py: 3, borderRadius: { xs: '4px', sm: '4px', md: '4px' }, fontSize: { xs: 9, sm: 14, md: 14 }, fontWeight: 600, textTransform: "capitalize",
                    }} >
                      {question.userResponse === "correct"
                        ? "Correct"
                        : (question.userResponse === null || question.userResponse === "unattempted")
                          ? "Not Answered"
                          : "Incorrect"}
                      {question.userResponse === "correct" ? (
                        <DoneIcon sx={{ fontSize: 16 }} />
                      ) : (question.userResponse === null || question.userResponse === "unattempted") ? (
                        <Typography sx={{ fontSize: 18, color: '#3F3F3F' }}>!</Typography>
                      ) : (
                        <CloseIcon sx={{ fontSize: 16 }} />
                      )}

                    </Box>

                    <Box sx={{
                      display: "flex", alignItems: "center", justifyContent: "center",
                      px: 1.5, py: 0.6, borderRadius: "4px",
                      fontSize: { xs: 9, sm: 10 }, fontWeight: 600, letterSpacing: "0.3px",
                      backgroundColor: "#f5f5f5", color: "#616161", border: "1px solid #e0e0e0",
                      whiteSpace: "nowrap", ml: 1,
                    }}>
                      {question.question_type}
                    </Box>
                  </Box>

                  <Typography variant="body2" sx={{ fontWeight: 600, color: 'black', fontSize: { xs: 12, sm: 13 } }}>
                    Time spent: {question?.timetaken ? question.timetaken.toFixed(1) : "0.0"} s
                  </Typography>

                  <Box sx={{ display: 'flex', flexWrap: 'wrap', columnGap: 3, rowGap: 0.5 }}>
                    <Typography variant="body2" sx={{ fontWeight: 400, color: '#616161', fontSize: { xs: 12, sm: 13 } }}>
                      Selected option:{" "}
                      <Box component="span" sx={{ fontWeight: 700, color: '#000' }}>
                        {getSelectedLabelCompact(question)}
                      </Box>
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 400, color: '#616161', fontSize: { xs: 12, sm: 13 } }}>
                      Correct answer:{" "}
                      <Box component="span" sx={{ fontWeight: 700, color: '#000' }}>
                        {getCorrectLabelCompact(question)}
                      </Box>
                    </Typography>
                  </Box>

                  <Divider sx={{ my: 0.5 }} />

                  <Box
                    onClick={() => setExpanded(expanded === question.id ? null : question.id)}
                    sx={{
                      display: 'flex', alignItems: 'center', gap: 0.3, cursor: 'pointer',
                      color: '#3d88fa', fontWeight: 600, fontSize: { xs: 12, sm: 13 },
                    }}
                  >
                    {expanded === question.id
                      ? "Hide Question and Explanation"
                      : "View Question and Explanation"}
                    <ExpandMoreIcon sx={{
                      fontSize: 18,
                      transform: expanded === question.id ? 'rotate(180deg)' : 'rotate(-90deg)',
                      transition: 'transform 0.2s',
                    }} />
                  </Box>
                </Box>

                <Box sx={{
                  display: { xs: 'none', sm: 'none', md: 'flex' },
                  flexDirection: 'row',
                  flex: 1,
                  alignItems: 'center',
                  gap: { xs: 1, sm: 2, md: 5 },
                  overflow: 'hidden',
                  minWidth: 0
                }}>


                  <Box sx={{
                    display: "flex", alignItems: "center", width: { xs: 100, sm: 130, md: 130 }, height: 30, justifyContent: "center", gap: 0.5,
                    backgroundColor: question.userResponse === "correct" ? "#e8f5e9" : (question.userResponse === null || question.userResponse === "unattempted") ? "#e3e8ef" : "#ffebee",
                    color: question.userResponse === "correct" ? "#2e7d32" : (question.userResponse === null || question.userResponse === "unattempted") ? "#3F3F3F" : "#d32f2f",
                    px: 1.2, py: 3, borderRadius: { xs: '4px', sm: '4px', md: '4px' }, fontSize: { xs: 9, sm: 14, md: 14 }, fontWeight: 600, textTransform: "capitalize",
                  }} >
                    {question.userResponse === "correct"
                      ? "Correct"
                      : (question.userResponse === null || question.userResponse === "unattempted")
                        ? "Not Answered"
                        : "Incorrect"}
                    {question.userResponse === "correct" ? (
                      <DoneIcon sx={{ fontSize: 16 }} />
                    ) : (question.userResponse === null || question.userResponse === "unattempted") ? (
                      <Typography sx={{ fontSize: 18, color: '#3F3F3F' }}>!</Typography>
                    ) : (
                      <CloseIcon sx={{ fontSize: 16 }} />
                    )}

                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 150,
                      height: 30,
                      borderRadius: "4px",
                      px: 2,
                      flexShrink: 0,

                      minWidth: { xs: 50, sm: 90, md: 90 },

                      fontSize: { xs: 8, sm: 10, md: 10 },
                      fontWeight: 600,
                      letterSpacing: "0.3px",

                      backgroundColor: "#f5f5f5",
                      color: "#616161",
                      border: "1px solid #e0e0e0",

                      whiteSpace: "nowrap",
                      textDecoration: "none",
                    }}
                  >
                    {question.question_type}
                  </Box>


                  <Box id='123' sx={{
                    ...(mobileLandscape
                      ? {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        columnGap: 2,
                        rowGap: 1,
                        flex: 1,
                        minWidth: 0,
                        flexWrap: "wrap",
                      }
                      : {
                        display: "flex",
                        flexDirection: { xs: "row", sm: "row", md: "row" },
                        justifyContent: { xs: "flex-start", sm: "flex-start", md: "flex-start" },
                        alignItems: "center",
                        rowGap: 1,
                        flex: 1,
                        minWidth: 0,
                        flexWrap: "nowrap",
                        overflowX: "auto",
                        columnGap: { xs: 1.5, sm: 3, md: 6 },
                        pb: 0.5,
                      })
                  }}>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: 'black', fontSize: { xs: 9, sm: 16, md: 14 } }}>
                      Time spent: {question?.timetaken ? question.timetaken.toFixed(1) : "0.0"} s
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: 'black', fontSize: { xs: 9, sm: 16, md: 14 } }}>
                      Selected option:{" "}
                      <Box component="span" sx={{ fontWeight: 600, color: 'inherit' }}>
                        {(() => {
                          try {
                            const parsedAnswer =
                              typeof question.answer === "string"
                                ? JSON.parse(question.answer)
                                : question.answer || {};

                            const options = Array.isArray(parsedAnswer?.mcqOptions)
                              ? parsedAnswer.mcqOptions
                              : [];

                            if (question.question_type?.toUpperCase() === 'NUMERIC') {
                              return question.selectedAnswer ?? '-';
                            }
                            if (isMultiAnswer(question)) {
                              const selectedArr = Array.isArray(question.selectedAnswer)
                                ? question.selectedAnswer
                                : (question.selectedAnswer ? [question.selectedAnswer] : []);
                              if (selectedArr.length === 0) return '-';
                              const labels = selectedArr.map(s => {
                                const idx = options.findIndex(opt => normalizeText(opt) === normalizeText(s));
                                return idx !== -1 ? String.fromCharCode(65 + idx) : '-';
                              });
                              return labels.join(', ');
                            }
                            let selected = question.selectedAnswer;
                            if (typeof selected === "string") {
                              try {
                                const parsed = JSON.parse(selected);
                                if (Array.isArray(parsed)) selected = parsed[0];
                                else if (typeof parsed === "object" && parsed !== null)
                                  selected = parsed.value || parsed.option || "";
                                else selected = parsed;
                              } catch {
                                // Not JSON, keep as-is
                              }
                            }

                            const normalizedSelected = normalizeText(selected);
                            const selectedIndex = options.findIndex(
                              (opt) => normalizeText(opt) === normalizedSelected
                            );
                            const selectedLabel =
                              selectedIndex !== -1 ? String.fromCharCode(65 + selectedIndex) : "-";

                            return selectedLabel ? `${selectedLabel}` : "-";
                          } catch (err) {
                            return "-";
                          }
                        })()}
                      </Box>


                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: 'black', fontSize: { xs: 9, sm: 16, md: 14 } }}> {/* correct answer */}
                      Correct answer:{" "}
                      <Box component="span" sx={{ fontWeight: 600, color: 'inherit' }}>
                        {(() => {
                          const parsedAnswer =
                            typeof question.answer === "string"
                              ? JSON.parse(question.answer)
                              : question.answer;

                          if (question.question_type?.toUpperCase() === 'NUMERIC') {
                            if (parsedAnswer?.answerType === 'range') {
                              return <>{`${parsedAnswer.minValue} – ${parsedAnswer.maxValue}`}</>;
                            }
                            return <>{parsedAnswer?.acceptableAnswers || '-'}</>;
                          }

                          const options = parsedAnswer?.mcqOptions || [];
                          const correctAnswers = parsedAnswer?.correctAnswer || [];

                          if (isMultiAnswer(question)) {
                            const correctLabels = correctAnswers
                              .map((val, idx) => val ? String.fromCharCode(65 + idx) : null)
                              .filter(Boolean);
                            return <>{correctLabels.join(', ') || '-'}</>;
                          }

                          const correctIndex = correctAnswers.findIndex((ans) => ans === true);
                          const correctLabel =
                            correctIndex !== -1 ? String.fromCharCode(65 + correctIndex) : "";

                          return (
                            <>
                              {correctLabel && `${correctLabel} `}
                            </>
                          );
                        })()}
                      </Box>
                    </Typography>
                  </Box>

                  <Button
                    size="small"
                    sx={{
                      color: "#000000ff",
                      textTransform: "none",
                      fontWeight: 500,
                      fontSize: { xs: 9, sm: 14, md: 14 },
                      borderRadius: { xs: '4px', sm: '4px', md: '4px' },
                      background: '#eee',
                      '&:hover': { background: '#eee' },
                      width: { xs: '100%', sm: 'auto' },
                      maxWidth: { xs: 180, sm: 280, md: 'unset' },
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      ml: { xs: 0, sm: 0 },
                      mt: { xs: 0, sm: 0 },
                      order: { xs: 2, sm: 0 },
                      alignSelf: { xs: 'flex-start', sm: 'flex-start' },
                      pl: { xs: 0.5, sm: 3, md: 3 },
                      pr: { xs: 0.5, sm: 3, md: 3 }
                    }}
                    endIcon={<ExpandMoreIcon sx={{ fontSize: 30 }} />}
                    onClick={() => setExpanded(expanded === question.id ? null : question.id)}
                  >
                    {expanded === question.id
                      ? "Hide Question and Explanation"
                      : "View Question and Explanation"}
                  </Button>
                </Box>
              </AccordionSummary>


              <AccordionDetails id='accordian'
                sx={{
                  backgroundColor: expanded === question.id ? '#eee' : '#fff',
                  p: { xs: 1.5, sm: 3, md: 3 },
                  border: { xs: '8px solid #fff', sm: '20px solid #fff', md: '20px solid #fff' },
                  borderRadius: { xs: 2, sm: 3.5, md: 4 }
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: isPassageVisible
                      ? { xs: 'column', md: 'column' }
                      : { xs: 'column', md: 'row' },
                    alignItems: 'flex-start',
                    gap: 2,
                    width: '100%',
                  }}
                >
                  <Box id='boxPassage1'
                    sx={{
                      flex: 1,
                      display: 'flex',
                      flexDirection: isPassageVisible ? { xs: 'column', sm: 'column', md: 'row' } : { xs: 'column', sm: 'column', md: 'column' },
                      pr: !isPassageVisible ? { md: 2 } : 0,
                      minWidth: 0,
                      width: isPassageVisible ? '100%' : '100%'
                    }}
                  >
                    {isPassageVisible && question?.passage && (
                      <>
                        <Box sx={{ flex: 1 }} id='boxPassage2'>
                          <Typography
                            variant="body1"
                            sx={{ fontWeight: 600, mb: 1, color: '#000' }}
                          >
                            PASSAGE:
                          </Typography>
                          <Typography
                            dangerouslySetInnerHTML={{ __html: question?.passage }}
                            variant="body2"
                            sx={{
                              lineHeight: 1.7, color: '#555', fontSize: { xs: 12, sm: 14, md: 14 }, wordBreak: "break-word",
                              "& ul, & ol": { paddingLeft: "20px" },
                              "& li": { marginBottom: "4px" }
                            }}
                          />
                        </Box>

                        <Divider
                          orientation="vertical"
                          flexItem
                          sx={{
                            borderColor: '#ccc',
                            display: { xs: 'none', md: 'block' },
                            mx: 1,
                          }}
                        />
                      </>
                    )}

                    <Divider
                      orientation="horizontal"
                      sx={{
                        borderColor: '#ddd',
                        display: isPassageVisible ? { xs: 'block', md: 'none' } : { xs: 'none', md: 'none' },
                        my: 2,
                      }}
                    />

                    <Box id='questionBox'
                      sx={{
                        flex: !isPassageVisible ? 1 : 'unset',
                        width: isPassageVisible ? { xs: '100%', sm: '100%', md: '50%' } : { xs: '100%', sm: '100%', md: '100%' },
                        pr: !isPassageVisible ? { md: 2 } : 0,
                        minWidth: 0,
                        ml: { xs: 0, sm: 0, md: 1 }
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{ mb: 1, mt: 1, fontWeight: 600, color: '#000' }}
                      >
                        QUESTION:
                      </Typography>

                      <Typography
                        variant="body2"
                        sx={{
                          mb: 3, lineHeight: 1.7, color: '#333', fontSize: { xs: 12, sm: 14, md: 14 }, wordBreak: "break-word",
                          "& ul, & ol": { paddingLeft: "20px" },
                          "& li": { marginBottom: "4px" }
                        }}
                        dangerouslySetInnerHTML={{ __html: question?.question_text }}
                      />

                      <Grid container spacing={1.5} sx={{ mb: 3, flexDirection: 'column' }}>
                        {(() => {
                          const parsedAnswer =
                            typeof question.answer === 'string'
                              ? JSON.parse(question.answer)
                              : question.answer;

                          if (question.question_type === 'NUMERIC') {
                            const isCorrect = question.userResponse === 'correct';
                            const correctDisplay = parsedAnswer?.answerType === 'range'
                              ? `${parsedAnswer.minValue} – ${parsedAnswer.maxValue}`
                              : parsedAnswer?.acceptableAnswers || '-';
                            return (
                              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 3, mt: 1, px: { xs: 1, sm: 2 } }}>
                                <Box sx={{
                                  p: { xs: 1.5, sm: 2.5 }, borderRadius: 2,
                                  border: `1.8px solid ${isCorrect ? '#2e7d32' : '#d32f2f'}`,
                                  backgroundColor: isCorrect ? '#e8f5e9' : '#ffebee',
                                }}>
                                  <Typography variant="body2" sx={{ fontWeight: 600, fontSize: { xs: 12, sm: 14 }, pl: 1 }}>
                                    Your answer:{" "}
                                    <span style={{ fontWeight: 400 }}>
                                      {question.selectedAnswer ?? '—'}
                                    </span>
                                  </Typography>
                                </Box>
                                <Box sx={{
                                  p: { xs: 1.5, sm: 2.5 }, borderRadius: 2,
                                  border: '1.8px solid #2e7d32',
                                  backgroundColor: '#e8f5e9',
                                }}>
                                  <Typography variant="body2" sx={{ fontWeight: 600, fontSize: { xs: 12, sm: 14 }, pl: 1 }}>
                                    Correct answer:{" "}
                                    <span style={{ fontWeight: 400 }}>{correctDisplay}</span>
                                  </Typography>
                                  {parsedAnswer?.answerType === 'range' && (
                                    <Typography variant="caption" sx={{ color: '#555', mt: 0.5, display: 'block' }}>
                                      Acceptable range: {parsedAnswer.minValue} to {parsedAnswer.maxValue}
                                    </Typography>
                                  )}
                                </Box>
                              </Box>
                            );
                          }
                          const options = parsedAnswer?.mcqOptions || [];
                          const correctAnswers = parsedAnswer?.correctAnswer || [];

                          return options.map((value, index) => {
                            const key = String.fromCharCode(65 + index);
                            const isCorrect = correctAnswers[index] === true;
                            const isSelected = isMultiAnswer(question)
                              ? Array.isArray(question.selectedAnswer)
                                ? question.selectedAnswer.some(s => normalizeText(s) === normalizeText(value))
                                : false
                              : normalizeText(question.selectedAnswer) === normalizeText(value);
                            const isWrong = isSelected && !isCorrect;

                            return (
                              <Grid item xs={12} key={key}>
                                <Box
                                  sx={{
                                    borderRadius: '8px',
                                    border: isWrong
                                      ? '1.8px solid #d32f2f'
                                      : isCorrect
                                        ? '1.8px solid #2e7d32'
                                        : '1px solid #000',
                                    p: 1.8,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    backgroundColor: isCorrect
                                      ? '#e8f5e9'
                                      : isWrong
                                        ? '#ffebee'
                                        : '#eee',
                                    color: isCorrect
                                      ? '#000'
                                      : isWrong
                                        ? '#000'
                                        : '#000',
                                    transition: 'all 0.2s ease',
                                    borderBottom: isCorrect
                                      ? '1.8px solid #2e7d32 !important'
                                      : isWrong
                                        ? '1.8px solid #d32f2f !important'
                                        : '1px solid #000 !important',
                                  }}
                                >
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      p: 1,
                                      fontWeight: 500,
                                      display: 'flex',
                                      alignItems: 'center',
                                      fontSize: { xs: 12, sm: 14, md: 14 },
                                      "& ul": { listStyle: "none" },
                                      "& ol": { listStyle: "none" },
                                      "& li": { listStyle: "none" },
                                    }}
                                  >
                                    <Box sx={{
                                      width: { xs: 20, sm: 24, md: 28 }, height: { xs: 20, sm: 24, md: 28 }, minWidth: { xs: 20, sm: 24, md: 28 }, minHeight: { xs: 20, sm: 24, md: 28 }, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 500, fontSize: { xs: 10, sm: 14, md: 14 }, borderRadius: '50%',
                                      border: isCorrect ? '2px solid #10B981' : isWrong ? '2px solid #F43F5E' : '1px solid #000',
                                      backgroundColor: isCorrect ? '#10B981' : isWrong ? '#F43F5E' : '#F4F4F4',
                                      color: isCorrect ? '#fff' : isWrong ? '#fff' : '#000', transition: 'all 0.2s', marginRight: 1.5, mb: '2px'
                                    }} >
                                      {key}
                                    </Box>
                                    <span dangerouslySetInnerHTML={{ __html: value }} />
                                  </Typography>

                                  {isCorrect && (
                                    <DoneIcon
                                      sx={{ color: '#2e7d32', marginRight: '10px' }}
                                    />
                                  )}
                                  {isWrong && (
                                    <CloseIcon sx={{ color: '#d32f2f', marginRight: '10px' }} />
                                  )}
                                </Box>
                              </Grid>
                            );
                          });
                        })()}
                      </Grid>
                    </Box>
                  </Box>

                  <Divider
                    sx={{
                      borderBottomWidth: 'thin',
                      borderColor: '#ccc',
                      marginTop: '0px',
                      marginBottom: '14px',
                    }}
                    orientation="horizontal"
                    flexItem
                  />

                  {!isPassageVisible && (
                    <Divider
                      orientation="vertical"
                      flexItem
                      sx={{
                        display: { xs: 'none', md: 'block' },
                        borderColor: '#e0e0e0',
                        mx: 0,
                        my: 0,
                      }}
                    />
                  )}

                  <Box
                    sx={{
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      pl: !isPassageVisible ? { md: 2 } : 0,
                      minWidth: 0,
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, mb: 1, color: '#143681' }}
                    >
                      EXPLANATION:
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{
                        lineHeight: 1.7, color: '#555', fontSize: { xs: 12, sm: 14, md: 14 }, wordBreak: "break-word",
                        "& ul, & ol": { paddingLeft: "20px" },
                        "& li": { marginBottom: "4px" }
                      }}
                      dangerouslySetInnerHTML={{ __html: question?.justification }}
                    />
                  </Box>
                </Box>
              </AccordionDetails>




            </Accordion>
          </Card>
        ))
          :
          <Card sx={{ borderRadius: 2, boxShadow: "none", border: "1px solid #e0e0e0", mb: 2, overflow: "hidden", backgroundColor: "#fff", p: 2 }}>
            <Typography variant="body2" sx={{ color: "#616161", fontWeight: 500 }}>You may have skipped or left some questions unanswered. </Typography> </Card>
        }

        {totalQuestions > INITIAL_COUNT && (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #eee', pt: 2, mt: 1 }}>
            <Button
              variant="contained"
              disableElevation
              onClick={() =>
                hasMore
                  ? setVisibleCount((c) => Math.min(c + STEP, totalQuestions))
                  : setVisibleCount(INITIAL_COUNT)
              }
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                fontSize: { xs: 12, sm: 14 },
                borderRadius: '6px',
                px: 3,
                backgroundColor: '#2563eb',
                '&:hover': { backgroundColor: '#1d4ed8' },
              }}
            >
              {hasMore ? 'Show More' : 'Show Less'}
            </Button>
          </Box>
        )}
      </Box>
        </div>
    </>
  );
};